class CartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement =
			document.getElementById('shopping-cart-line-item-status') ||
			document.getElementById('CartDrawer-LineItemStatus');

		this.currentItemCount = Array.from(
			this.querySelectorAll('[name="updates[]"]'),
		).reduce(
			(total, quantityInput) => total + parseInt(quantityInput.value),
			0,
		);

		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);

		this.addEventListener('change', this.debouncedOnChange.bind(this));

		this.checkCartIsEmpty();
		if (document.body.classList.contains('template-cart')) {
			this.initializeNoteFeature();
		}

	}

	onChange(event) {
		if(!event.target.id.includes('display-cart-note')){
			this.updateQuantity(
				event.target.dataset.index,
				event.target.value,
				document.activeElement.getAttribute('name'),
			);
		}
	}

	getSectionsToRender() {
		return [
			{
        id: 'header',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble'
      },
			{
				id: 'main-cart-items',
				section: document.getElementById('main-cart-items').dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'cart-live-region-text',
				section: 'cart-live-region-text',
				selector: '.shopify-section',
			},
			{
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer').dataset.id,
				selector: '.js-contents-footer',
			},
			{
				id: 'main-cart-header',
				section: document.getElementById('main-cart-header').dataset.id,
				selector: '.cart__count',
			}
		];
	}

	updateQuantity(line, quantity, name) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter)
					cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						'is-empty',
						parsedState.item_count === 0,
					);

					
				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector,
					);
				});

				this.updateLiveRegions(line, parsedState.item_count);
				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`),
							)
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector('.drawer__inner-empty'),
						cartDrawerWrapper.querySelector('a'),
					);
				} else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector('.cart-item__name'),
					);
				}
				this.disableLoading();
			})
			.finally(() => {
        		document.dispatchEvent(
					new CustomEvent('productRecommendations:revive'),
				);
      })
			.catch(() => {
				this.querySelectorAll('.loading-overlay').forEach((overlay) =>
					overlay.classList.add('hidden'),
				);
				const errors =
					document.getElementById('cart-errors') ||
					document.getElementById('CartDrawer-CartErrors');
				errors.textContent = window.cartStrings.error;
				this.disableLoading();
			});			
	}

	updateLiveRegions(line, itemCount) {
		if (this.currentItemCount === itemCount) {
			const lineItemError =
				document.getElementById(`Line-item-error-${line}`) ||
				document.getElementById(`CartDrawer-LineItemError-${line}`);
			const quantityElement =
				document.getElementById(`Quantity-${line}`) ||
				document.getElementById(`Drawer-quantity-${line}`);

			lineItemError.querySelector('.cart-item__error-text').innerHTML =
				window.cartStrings.quantityError.replace(
					'[quantity]',
					quantityElement.value,
				);
		}

		this.currentItemCount = itemCount;
		this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus =
			document.getElementById('cart-live-region-text') ||
			document.getElementById('CartDrawer-LiveRegionText');
		cartStatus.setAttribute('aria-hidden', false);

		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById('main-cart-items') ||
			document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.add('cart__items--disabled');

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`,
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`,
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove('hidden'),
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading() {
		const mainCartItems =
			document.getElementById('main-cart-items') ||
			document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.remove('cart__items--disabled');
	}

	checkCartIsEmpty() {
		// Fetch the cart data using the GET /cart.js endpoint
		fetch('/cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			}
		})
		.then(response => response.json())
		.then(cart => {
			let cartReco = document.querySelector('.c-cart-drawer__reco')
			
			if (cart.item_count === 0) {
				if (cartReco && 
					cartReco.classList.contains('u-hidden') === false
				) {
					cartReco.classList.add('u-hidden');
					this.closest('cart-drawer').deleteNote()
					if(document.querySelector('[data-note-btn-delete]').classList.contains('u-hidden')) this.closest('cart-drawer').toggleNote()
				}		
			} else {
				if (
					cartReco && cartReco.classList.contains('u-hidden')
				) {
					cartReco.classList.remove('u-hidden');
				}			
			}
		})
		.catch(error => {
			console.error('Error fetching cart:', error);
		});
	}

	initializeNoteFeature() {
		this.btnsValidNote = document.querySelectorAll('[data-note-btn]');
		this.btnDeleteNote = document.querySelector('[data-note-btn-delete]');
		this.textAreaNote = document.querySelector('[data-note-textarea]');
		this.noteFakeField = document.querySelector('[data-note-fake-field]');
		this.noteCountLabel = document.querySelector('[data-note-count]');

		if (this.textAreaNote) {
			this.noteCountLabel.innerHTML = this.textAreaNote.value.length;
			this.textAreaNote.addEventListener('input', (e) => {
				const textLength = this.textAreaNote.value.length;
				this.noteCountLabel.innerHTML = textLength;

				if (textLength > 0) {
					this.btnsValidNote[0].classList.remove('is-disable');
				} else {
					this.btnsValidNote[0].classList.add('is-disable');
				}

				let text = e.target.value;
				text = text.replace(
					/\b([a-zA-Z])([a-zA-Z]*)\b/g,
					function (match, p1, p2) {
						return p1 + p2.toLowerCase();
					},
				);
				e.target.value = text;
			});

		}

		this.btnsValidNote.forEach((btn) => {
			btn.addEventListener('click', this.toggleNote.bind(this));
		});

		if (this.btnDeleteNote) {
			this.btnDeleteNote.addEventListener('click', this.deleteNote.bind(this));
		}
	}

	toggleNote() {
		this.noteFakeField.innerHTML = this.textAreaNote.value;
		this.btnDeleteNote.classList.toggle('u-hidden');
		this.textAreaNote.classList.toggle('u-hidden');
		this.noteFakeField.classList.toggle('u-hidden');

		this.btnsValidNote.forEach((btn) => {
			btn.classList.toggle('!u-hidden');
		});
	}

	deleteNote() {
		document.querySelector('[data-note-display]').checked = false;
		document.querySelector('[data-note-content]').classList.add('u-hidden');
		this.textAreaNote.value = this.noteFakeField.innerHTML = '';
		this.noteCountLabel.innerHTML = '0';
		const body = JSON.stringify({note: ''});
		fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
	}
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      document.querySelector('[data-note-display]').addEventListener('click', (e) => {
        document.querySelector('[data-note-content]').classList.toggle('u-hidden', !e.target.checked)
        if(!e.target.checked) {
          this.closest('cart-items').deleteNote()
          if(document.querySelector('[data-note-btn-delete]').classList.contains('u-hidden')) this.closest('cart-items').toggleNote()
        }
      })

      this.addEventListener('change', debounce((event) => {
        if(event.target.value != 'on'){
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }
      }, 300));

		this.textAreaNote = document.querySelector('[data-note-textarea]');
	  	this.limitTextareaLinesAndDoubleBreaks();
		this.disableTextareaPaste();
    }

	limitTextareaLinesAndDoubleBreaks() {
		const maxLines = 5;
	
		this.textAreaNote.addEventListener('input', (e) => {
			let value = this.textAreaNote.value;
	
			// Prevent multiple blank lines
			value = value.replace(/\r\n/g, '\n').replace(/\n{2,}/g, '\n');
	
			// Limit to max lines
			const lines = value.split('\n').slice(0, maxLines);
			this.textAreaNote.value = lines.join('\n');
		});
	}
	
	disableTextareaPaste() {
		this.textAreaNote.addEventListener('paste', (e) => {
		  e.preventDefault();
		});
	}
  });
};
class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', (event) => {
			event.preventDefault();
			const cartItems =
				this.closest('cart-items') || this.closest('cart-drawer-items');
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}
	
}

customElements.define('cart-remove-button', CartRemoveButton);

